import { useLayoutEffect } from 'react';
import { create } from 'zustand';
import { type CustomerTimePickerSurface } from './customerTimePickerSurface';

type State = {
  surface: CustomerTimePickerSurface | null;
  setSurface: (surface: CustomerTimePickerSurface | null) => void;
};

/** The mounted time-picker slot. The page banner reads this on the shared edit URL. */
export const useTimePickerNoticeSurfaceStore = create<State>((set) => ({
  surface: null,
  setSurface: (surface) => set({ surface })
}));

export const usePublishTimePickerSurface = (surface: CustomerTimePickerSurface) => {
  const setSurface = useTimePickerNoticeSurfaceStore((state) => state.setSurface);

  useLayoutEffect(() => {
    setSurface(surface);
    return () => setSurface(null);
  }, [setSurface, surface]);
};
